import { render, staticRenderFns } from "./notice-welcome-tcr-home-dialog.vue?vue&type=template&id=0b197767&scoped=true&"
import script from "./notice-welcome-tcr-home-dialog.vue?vue&type=script&lang=js&"
export * from "./notice-welcome-tcr-home-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b197767",
  null
  
)

export default component.exports